/**
 * Telemetry utilities for consuming Prism API telemetry instructions
 *
 * This module provides client-side utilities for handling telemetry instructions
 * generated by the Prism API. All utilities fail silently to prevent breaking
 * user experience when telemetry is unavailable.
 *
 * Form field tracking is handled by the TrackFormAttribution component
 * from @tuic/tracking, which uses native HTML form attributes.
 */

export * from './telemetry-to-click-attributes';
export * from './telemetry-to-form-attributes';
export * from './fire-immediate-telemetry';
export * from './extract-immediate-telemetry';
export * from './hooks/use-dialog-telemetry';
